import * as React from 'react';
import '@ramsey-design-system/tokens/dist/tokens.css';
import styles from './user-lesson-progress.module.css';
import { LessonData } from '../../types';

// Components
import UserOverview from '../../components/UserOverview/UserOverview';
import ActionItems from '../../components/ActionItems/ActionItems';

type UserLessonProgressProps = {
  lessonData: LessonData;
  courseTitleColor?: string;
  actionItemsTitle?: string;
  truncateActionItemText?: boolean;
  collapsedActionGroupId?: string;
  showPills?: boolean;
  notificationBanner?: JSX.Element;
};

const defaultProps = {
  truncateActionItemText: true,
};

const renderActionGroups = ({
  lessonData,
  actionItemsTitle,
  truncateActionItemText,
  collapsedActionGroupId,
  showPills,
}: UserLessonProgressProps) => {
  // Remove the first 'video' element. Assuming FPU here...
  const actionGroups = [...lessonData.action_groups];
  actionGroups.shift();

  return actionGroups.map((actionGroup, index) => {
    const showTitle = index === 0;
    const collapse = actionGroup.id === collapsedActionGroupId;
    return (
      <ActionItems
        key={index}
        lessonNumber={lessonData.subtitle}
        actionGroup={actionGroup}
        showTitle={showTitle}
        title={actionItemsTitle}
        truncateText={truncateActionItemText}
        className={styles.action_item_container}
        collapse={collapse}
        showPills={showPills}
      />
    );
  });
};

/**
 * Deprecated. Use `UserLessonOverview` for dashboard viewing
 */
const UserLessonProgress = ({
  courseTitleColor,
  lessonData,
  actionItemsTitle,
  truncateActionItemText,
  collapsedActionGroupId = 'multi-survey',
  showPills = false,
  notificationBanner,
}: UserLessonProgressProps) => {
  const inlineStyles = courseTitleColor ? { color: courseTitleColor } : {};
  return (
    <div className="UserLessonProgress">
      <h2
        style={inlineStyles}
        className={styles.title}
        data-testid="course-title"
      >
        {lessonData.course_title}
      </h2>
      {notificationBanner}
      <UserOverview lessonData={lessonData} />
      {renderActionGroups({
        lessonData,
        actionItemsTitle,
        truncateActionItemText,
        collapsedActionGroupId,
        showPills,
      })}
    </div>
  );
};

UserLessonProgress.defaultProps = defaultProps;

export default UserLessonProgress;
